import { CSSObject } from '@chakra-ui/react';

export const ModalOverlay = (): CSSObject => ({
  bg: 'blackAlpha.700',
});
